import React from 'react';
import { BodyText, DataGrid, TextTag, NavigationItem } from 'ui-toolkit';
import { IVendorTaxCertificationData } from '../../types/vendorDashboard/IVendorTaxCertifications';
import { prettyVendorStatus, vendorStatusTagColor } from '../../types/order/title/eTaxCertificationRequestStatus';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';
import { IAddressData } from '../../ui-toolkit/orders/interfaces/IAddressResponse';
import { getDaysAgoString } from '../../ui-toolkit/utilities/getDaysAgoString';
import { DateFormat, getDateString } from '../../ui-toolkit/utilities/getDateString';

interface ITaxCertificationsTableProps {
  taxCerts: IVendorTaxCertificationData[];
  loading: boolean;
}

export const TaxCertificationsTable: React.FC<ITaxCertificationsTableProps> = ({ taxCerts, loading }) => {
  return (
    <DataGrid
      columns={[
        {
          dataField: 'fileNumber',
          formatter: (_, row) => (
            <NavigationItem
              intent={'primary'}
              appearance={'minimal'}
              text={row.fileNumber}
              to={ClientUrlFactory().urlFor.vendorTaxCertification(row.orderId)}
              isInline
            />
          ),
          text: 'ID',
        },
        {
          dataField: 'borrowers',
          text: 'Borrower(s)',
        },
        {
          dataField: 'address',
          formatter: ((cell: IAddressData) => <BodyText>{`${cell.city}, ${cell.stateAbbreviation}`}</BodyText>) as (
            cell: any
          ) => React.ReactNode, //temporary cast until react-bootstrap-table-next types are fixed
          text: 'Location',
        },
        {
          dataField: 'timeEnteredQueue',
          formatter: ((cell?: string) => <BodyText>{cell && getDaysAgoString(cell)}</BodyText>) as (
            cell: any
          ) => React.ReactNode, //temporary cast until react-bootstrap-table-next types are fixed
          text: 'In Queue',
        },
        {
          dataField: 'eta',
          formatter: ((cell?: string) => <BodyText>{cell && getDateString(DateFormat.long, cell)}</BodyText>) as (
            cell: any
          ) => React.ReactNode, //temporary cast until react-bootstrap-table-next types are fixed
          text: 'ETA',
        },
        {
          dataField: 'status',
          formatter: (_, row) => (
            <TextTag type={vendorStatusTagColor[row.status]} text={prettyVendorStatus[row.status]} />
          ),
          text: 'Status',
        },
      ]}
      keyField={'taxCertificationRequestId'}
      data={taxCerts || []}
      loading={loading}
    />
  );
};
